<template>
  <div class="footer__terms">
    <p>
      Finance Magnates is a global B2B provider of multi-asset trading news,
      research and events with special focus on electronic trading, banking, and
      investing. Copyright © {{ currentYear }} FINANCE MAGNATES CY LIMITED,
      registration number HE 433362, Apostolou Andrea 11, Hyper Tower, 3rd
      Floor, 4007 Mesa Geitonia, Limassol, Cyprus. All rights
      reserved.<a-visibility
        show
        :on="[$breakpoint.tablet, $breakpoint.desktopSm]"
        ><br /></a-visibility
      >For more information, read our

      <a-link class="footer__terms-link" :to="linkToTermsOfUse">Terms, </a-link>
      <a-link class="footer__terms-link" :to="linkToCookies">Cookies </a-link>
      and
      <a-link class="footer__terms-link" :to="linkToPrivacyPolicy"
        >Privacy Notice
      </a-link>
      <span class="footer__action-links">
        <a
          href="#"
          class="footer__manage-cookies-link"
          @click.prevent="$_cmp_toggleCookiePreferencesPopup"
          >Manage Cookies</a
        >
        <footer-do-not-sell-link class="footer__do-not-sell-link" />
      </span>
    </p>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { ROUTE_NAME } from 'enums/routes'
import { LINK_GENERATOR } from 'enums/links'
import FooterDoNotSellLink from '@/components/AFooter/AFooterContent/FooterDoNotSellLink'

export default {
  name: 'AFooterTerms',
  components: { FooterDoNotSellLink },
  mixins: [mixins.urlGenerators, mixins.cmp],
  data() {
    return {
      ROUTE_NAME,
      currentYear: new Date().getFullYear(),
      linkToTermsOfUse: LINK_GENERATOR.TERMS_OF_USE(),
      linkToCookies: LINK_GENERATOR.COOKIES(),
      linkToPrivacyPolicy: LINK_GENERATOR.PRIVACY_POLICY()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer__terms {
  font-size: 11px;
  line-height: 15px;
  margin-top: 40px;
  max-width: 795px;

  & * {
  }

  @include mobile {
    margin: 0;
    padding-top: 10px;
    border-top: 1px solid black;
  }
}

.footer__terms-link,
.footer__manage-cookies-link {
  text-decoration: underline;
  color: $c--white;
}

.footer__manage-cookies-link {
  color: $c--main;

  @include desktop-sm {
    margin-left: 20px;
  }

  @include mobile {
    width: 100%;
    display: block;
    margin: 15px 0 0;
    text-align: center;
  }
}

.footer__action-links {
  display: inline;

  @media (min-width: #{$desktop-sm + 1}) {
    display: block;
  }

  @include mobile {
    display: block;
    text-align: center;
  }
}

.footer__do-not-sell-link {
  margin-left: 20px;

  @include mobile {
    width: 100%;
    display: block;
    margin: 15px 0 0;
    text-align: center;
  }
}
</style>
